import { MemberMigrationRequestOptionType, MemberMigrationResponseType } from '../types';
import { AccountUserApiV2 } from '../../../../../../../lib/api/account/user/AccountUserApiV2';

export const MemberMigrationRepository = {
  migrateMember: (payload: MemberMigrationRequestOptionType): Promise<MemberMigrationResponseType> => {
    return AccountUserApiV2.migrateMember(payload);
  },
};
